import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useToast } from '../../context/ToastContext';
import FormEmpresa from './FormEmpresa';

export default function PaginaEmpresa() {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const ehNova = !publicId;
  const [empresa, setEmpresa] = useState(null);
  const [carregando, setCarregando] = useState(!ehNova);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (ehNova) return;
    api
      .get(`/empresas/${publicId}`)
      .then((r) => setEmpresa(r.data))
      // Achado em auditoria 2026-09-18: sem `.catch`, uma falha (publicId
      // inválido, sessão expirada, rede) deixava `empresa` em `null` sem
      // aviso — a tela renderizava o formulário como se fosse "vazio",
      // sob o título "Editar", parecendo que o registro só não tinha dado.
      .catch((err) => {
        setErro(true);
        toast.erro(err.message || 'Não foi possível carregar a empresa');
      })
      .finally(() => setCarregando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicId, ehNova]);

  async function salvar(dados) {
    if (ehNova) {
      await api.post('/empresas', dados);
      toast.sucesso('Empresa criada com sucesso.');
    } else {
      await api.put(`/empresas/${publicId}`, dados);
      toast.sucesso('Empresa atualizada com sucesso.');
    }
    navigate('/empresas');
  }

  return (
    <>
      <h1 className="h4 mb-4">{ehNova ? 'Nova empresa' : 'Editar empresa'}</h1>
      {carregando ? (
        <Spinner animation="border" />
      ) : (
        !erro && <FormEmpresa ehNova={ehNova} empresaInicial={empresa} aoSalvar={salvar} />
      )}
    </>
  );
}
